export default __webpack_public_path__ + "static/Ivory_sky-2225dc3d7cc7b60f3dd38782b03d69b0.png";